module.exports = __webpack_public_path__ + "static/img/中国电建-N.8639d7f6.png";